import r from "./CouponPageNormal.vue2.js";
import { openBlock as s, createElementBlock as c, Fragment as d, renderList as i, createElementVNode as o, toDisplayString as n, createTextVNode as l, pushScopeId as u, popScopeId as _ } from "vue";
/* empty css                      */
import h from "../../_virtual/_plugin-vue_export-helper.js";
const C = (e) => (u("data-v-f2c7bc9a"), e = e(), _(), e), f = { class: "coupon-list" }, m = { class: "Galyon" }, y = { class: "coupon-list-title" }, v = /* @__PURE__ */ C(() => /* @__PURE__ */ o("br", null, null, -1)), k = { class: "Galyon" }, S = { class: "Galyon-Bold" }, $ = ["onClick"], b = ["onClick"];
function I(e, N, w, B, E, G) {
  return s(), c("ul", f, [
    (s(!0), c(d, null, i(e.couponShowCaseList, (t, p) => (s(), c("li", { key: p }, [
      o("div", null, [
        o("h2", m, n(t.head), 1),
        o("div", y, [
          l(n(t.result) + " ", 1),
          v,
          l(n(t.phrase1), 1)
        ]),
        o("p", k, [
          l(" USE CODE: "),
          o("em", S, n(t.couponCode), 1)
        ]),
        o("input", {
          type: "button",
          class: "clip-btn clipped Galyon-Bold",
          value: "CLIP COUPON",
          onClick: (a) => e.CopyCoupon(t.couponCode)
        }, null, 8, $)
      ]),
      o("a", {
        onClick: (a) => e.CopyAndJump(t.couponCode),
        href: "jvascript:;",
        class: "coupon-shop-now"
      }, "Shop Now", 8, b)
    ]))), 128))
  ]);
}
const D = /* @__PURE__ */ h(r, [["render", I], ["__scopeId", "data-v-f2c7bc9a"]]);
export {
  D as default
};
